export default __webpack_public_path__ + "static/media/desk-clean-img3.7de223f5.png";